module.exports = __webpack_public_path__ + "static/28(3)-04e63875b53795d901b0be6da316b658.jpg";